import {
  Button,
  IconButton,
  InputAdornment,
  Link,
  MenuItem,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { IoInformation, IoInformationCircle } from "react-icons/io5";
import { MdDelete } from "react-icons/md";
import EditableSelect from "../../../components/EditableSelect";
import EditableTextView from "../../../components/EditableTextView";
import MediaCard from "../../../components/MediaCard";
import MediaManager from "../../../components/MediaManager";
import Constants from "../../../data/Constants";
import useMediaManager from "../../../hooks/useMediaManager";

function TopicView(props) {
  const [topic, setTopic] = props.topicHooks;
  const [curriculum, setCurriculum] = props.curriculumHooks;
  const [mediaManager, setMediaManager] = useMediaManager();

  useEffect(() => {
    console.log(props.curriculumHooks);
    if(props.curriculumHooks?.curriculum?.type==="recorded"){

      setTopic({ ...topic, type: "Recorded" });
    }
  }, []);

  return (
    <div className="h-full">
      <h1 className="font-extrabold text-lg my-3 text-center">Topic View</h1>

      <div className="m-2">
        <TextField
          label="Topic Name"
          variant="filled"
          size="small"
          value={topic.name ?? ""}
          onChange={(e) => setTopic({ ...topic, name: e.target.value })}
          required
          fullWidth
        />
      </div>

      <div className="m-2">
        <TextField
          label="Type"
          variant="filled"
          size="small"
          required
          select
          fullWidth
          value={topic.type}
          onChange={(e) => {
            setTopic({
              ...topic,
              type: e.target.value,
            });
          }}
        >
          {Constants.Topic.Types.map((type, index) => {
            // if (
            //   curriculum.type == "live-group" ||
            //   curriculum.type == "live-single"
            // ) {
            //   if (type == "Recorded") {
            //     return;
            //   }
            // } else {
            //   if (type == "Session") {
            //     return;
            //   }
            // }

            return (
              <MenuItem key={index} value={type}>
                {type}
              </MenuItem>
            );
          })}
        </TextField>
      </div>

      {topic.type == "Link" && (
        <div className="m-2">
          <TextField
            label="Assignent Link"
            variant="filled"
            type={"url"}
            size="small"
            value={topic.attachments ? topic.attachments[0] ?? "" : ""}
            onChange={(e) =>
              setTopic({ ...topic, attachments: [e.target.value] })
            }
            required
            fullWidth
          />
        </div>
      )}

      <div className="m-2">
        <TextField
          label="Topic Duration"
          variant="filled"
          size="small"
          value={topic.minutes ?? ""}
          onChange={(e) => setTopic({ ...topic, minutes: e.target.value })}
          InputProps={{
            endAdornment: (
              <InputAdornment position="start">Mins</InputAdornment>
            ),
          }}
          required
          fullWidth
          type="number"
        />
      </div>

      <div className="m-2">
        <TextField
          label="Topic Description"
          variant="filled"
          size="small"
          value={topic.description ?? ""}
          onChange={(e) => setTopic({ ...topic, description: e.target.value })}
          required
          fullWidth
          multiline
        />
      </div>

      {topic.type == "Session" && (
        <div className="flex gap-1 items-center justify-center my-2 text-sm text-gray-700">
          <IoInformationCircle size={22} /> Sessions can be scheduled in Course
          Class
        </div>
      )}

      {/* Topic = Recorded  */}

      {topic.type == "Recorded" && (
        <div className={"flex flex-col gap-3 " + props.className}>
          <div className="font-bold">Video File:</div>
          <Button
            variant="outlined"
            onClick={() => {
              setMediaManager({
                open: true,
                type: "Video",
                onSelect: (media) => {
                  setTopic({ ...topic, video: media, videoUrl: media.url });
                },
              });
            }}
          >
            <span className="font-bold"> Upload Video</span>
          </Button>

          {topic.video && (
            <MediaCard
              media={topic.video}
              onClose={() => {
                setTopic({ ...topic, video: undefined });
              }}
            />
          )}
        </div>
      )}

      {/* Topic = Assignment  */}

      {topic.type == "Assignment" && (
        <div className={"flex flex-col gap-3 "}>
          <div className="font-bold">Assignment Files:</div>
          <Button
            variant="outlined"
            onClick={() => {
              setMediaManager({
                open: true,
                onSelect: (media) => {
                  const temp = topic.attachments ?? [];
                  temp.push(media.url);
                  setTopic({ ...topic, attachments: temp });
                },
              });
            }}
          >
            <span className="font-bold"> Upload Assignments</span>
          </Button>

          {topic.attachments &&
            topic.attachments.map((url, index) => {
              return (
                <div
                  className="bg-blue-100 p-2 rounded-lg flex items-center"
                  key={index}
                >
                  <Link
                    href={url}
                    target="_blank"
                    className="flex-grow text-sm max-w-sm"
                  >
                    {url}
                  </Link>

                  <IconButton
                    className="justify-end"
                    onClick={() => {
                      const temp = topic.attachments;
                      temp.splice(index, 1);
                      setTopic({ ...topic, attachments: temp });
                    }}
                  >
                    <MdDelete size={20} />
                  </IconButton>
                </div>
              );
            })}
        </div>
      )}

      {
        <MediaManager
          open={mediaManager.open}
          type={mediaManager.type}
          onClose={() => {
            setMediaManager({ ...mediaManager, open: false });
          }}
          onSelect={mediaManager.onSelect}
        />
      }
    </div>
  );
}

export default TopicView;
